<template>
  <div class="header">
    <GroupSelect
      label="エリア"
      :group="group"
      :value="area"
      @input="groupSelectHandler($event)"
    />
    <div class="data-select">
      <v-btn
        v-for="( span, i ) in spans"
        :key="span"
        :outline="selectedSpan !== i"
        :dark="selectedSpan === i"
        icon
        round
        color="teal darken-1"
        class="data-select__btn"
        @click="dataSelectHandler(i)"
      >
        <span class="data-select__text">{{ span }}</span>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { GroupSelect } from '@/components/input'

export default {
  components: {
    GroupSelect
  },
  data () {
    return {
      spans: ['週', '月']
    }
  },
  computed: {
    ...mapState('groups', ['group']),
    ...mapState('dashboard', ['area', 'selectedSpan'])
  },
  methods: {
    ...mapMutations('dashboard', ['selectSpan', 'setArea']),
    groupSelectHandler (e) {
      this.setArea(e)
      this.$emit('start-loader')
    },
    dataSelectHandler (i) {
      this.selectSpan(i)
      this.$emit('start-loader')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0 32px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.data-select {
  margin-right: 15px;
  &__btn {
    margin-left: 12px;
  }
  &__span {
    font-weight: bold;
  }
}
/deep/.v-input {
  flex: unset;
  display: block;

  .v-select__selections {
    .v-select__selection--comma {
      min-width: 150px;
      white-space: nowrap;
      margin-right: 24px;
    }
    input {
      width: 0px;
    }
  }
}
</style>
